export default __webpack_public_path__ + "static/media/imcosun.25a6599d.svg";